import { createSelector } from 'selectors'

import { constant } from './feedback-messenger-window-wysiwyg.constant'

const getFeedbackMessengerWindowWysiwyg = () => createSelector<HTMLElement>({ selector: constant.selector.target })

export const feedbackMessengerWindowWysiwygSelector = {
	getFeedbackMessengerWindowWysiwyg,
}
